import React, { Component } from 'react';
import { Modal, Button, Segment, Dimmer, Loader, Message } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import PaymentTab from './Tab';
import Coupon from './Coupon';
import TransactionTable from '../../../common/components/TransactionTable';
import { updateInPath } from '../../../../common/utils';
import withPayment from '../../containers/Payment';

class PaymentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coupons: '',
      calculation: [],
      loading: true,
      paypalError: false
    };

    props.calculatePrices(props.data, '', (calc) => {
      this.setState(s => updateInPath(s, 'calculation', calc));
      this.setState(s => updateInPath(s, 'loading', false));
    });
  }

  updateCoupons = (value) => {
    // TODO callbacks are not nice
    // TODO should also have error callback to hide the dimmer
    this.setState(s => updateInPath(s, 'coupons', value));
    this.setState(s => updateInPath(s, 'loading', true));
    this.props.calculatePrices(this.props.data, value, (calc) => {
      this.setState(s => updateInPath(s, 'calculation', calc));
      this.setState(s => updateInPath(s, 'loading', false));
    });
  };

  handlePurchaseOrderCreate = (orderDetails) => {
    this.setState(s => updateInPath(s, 'paypalError', false));
    this.props.createPurchaseOrder(orderDetails, this.state.calculation, () => {
      this.props.onClose(true);
    });
  }

  handlePaypalSuccess = (paymentData, calc, total, subtotal, tax) => {
    this.setState(s => updateInPath(s, 'paypalError', false));
    this.props.savePaypalSuccess(paymentData, calc, total, subtotal, tax, () => {
      this.props.onClose(true);
    });
  }

  handlePaypalError = (err) => {
    this.setState(s => updateInPath(s, 'paypalError', true));
    this.props.savePaypalError(err);
  }

  handlePaypalCancel = () => {}

  handleZeroPaymentSuccess = (calc) => {
    this.setState(s => updateInPath(s, 'paypalError', false));
    this.props.saveZeroPayment(calc, () => {
      this.props.onClose(true);
    });
  }
  
  render() {
    const { open, t, onClose } = this.props;

    return (
      <Modal open={open}>
        <Modal.Header content={t('private:payment.title')} />
        <Modal.Content>
          <Dimmer active={this.state.loading}>
            <Loader content={t('private:payment.loader')}/>
          </Dimmer>
          <PaymentTab
            data={this.state.calculation}
            payPalClient={{
              sandbox: 'AaDMiHC1PUim7Ed8nrmglbhe-E4UlYcgpG-NFzkopL0fl7-MdYUCvi0fWqEeRtNdzK6EGtx0-gPjiViZ',
              production: 'AawpOKPj2jvACSDv9sBW3JUeVqy4b3H-gtEMoolvTSpGj_J0qoSGtwlNPk9GGBLXbclVz2DX0dqe6cWw'
            }}
            payPalEnv={'production'}
            onPaypalSuccess={this.handlePaypalSuccess}
            onPaypalError={this.handlePaypalError}
            onPaypalCancel={this.handlePaypalCancel}
            onPurchaseOrderSuccess={this.handlePurchaseOrderCreate}
            onZeroPaymentSuccess={this.handleZeroPaymentSuccess}
          />
          { this.state.paypalError &&
            <Message warning>{t('private:payment.failed')}</Message> }
          <Segment>
            <Coupon onSubmit={this.updateCoupons} />
          </Segment>
          <TransactionTable data={this.state.calculation}/>
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            content={t('private:payment.cancel')}
            onClick={onClose} />
        </Modal.Actions>
      </Modal>
    );
  };
};

export default withPayment(withNamespaces(['private'])(PaymentModal));



// WEBPACK FOOTER //
// ./src/private/user/components/Payment/index.js